import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CollegaModalPage } from './collega-modal.page';

const routes: Routes = [
  {
    path: '',
    component: CollegaModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CollegaModalPageRoutingModule {}
